module.exports = __webpack_public_path__ + "static/img/xj_img7.17f3e7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xj_img7.jpg
// module id = gPgN
// module chunks = 4